import styled                      from 'styled-components';

import { NavBarVariants          } from 'src/components/features/common/nav-bar';
import { cssFlexColumn,
         cssFlexRow, 
         themeColors             } from 'src/providers/theme/shared';



export type CameraForCountLayout = {
    backgroundColor: string;
  
    paddings: number[];
    scrollableGap: number;
    addRollPadding: number;
    actionButtonPadding: number;
    layoutButtonPadding: number[];
  
    errorsIconColor: string;
    dividerColor: string;
  
    navbarVariant: NavBarVariants;

    gap: number[];
    width: number; 
    height: number;
    iconWidth: number; 
    iconHeight: number;
    border: number;
    margin: number

    viewerContainerWidth: number;
    viewerContainerHeight: number;

    controllersContainerPadding: string;
    resultContainerPadding: string;
  }

  export const layout_light: CameraForCountLayout = {
    backgroundColor: themeColors.PrimaryBlack,
  
    paddings: [20],
    scrollableGap: 8,
    addRollPadding: 20,
    actionButtonPadding: 20,
    layoutButtonPadding: [18, 16],
  
    errorsIconColor: themeColors.AccentRed1,
    dividerColor: themeColors.SecondaryGray3,
  
    navbarVariant: 'lightblue',

    gap: [3, 12, 24], 
    width: 100,
    height: 100,
    iconWidth: 44,
    iconHeight: 44,
    border: 1,
    margin: 47,
    viewerContainerWidth: 100,
    viewerContainerHeight: 70,
    controllersContainerPadding: '27px 0',
    resultContainerPadding: '27px 16px 0',
  }
  
  export const layout_dark: CameraForCountLayout = {
    ...layout_light,
  }

export const Screen = styled.div<{
    layout: CameraForCountLayout,
  }>`
    width: ${(args) => args.layout.width}vw;
    height: ${(args) => args.layout.height}dvh;

    ${cssFlexColumn};
  
    background-color: ${(args) => args.layout.backgroundColor};
  `

  export const ScreenBody = styled.div<{
    layout: CameraForCountLayout,
  }>`
    ${cssFlexColumn};
    height: ${(args) => args.layout.height}dvh;
    flex-grow: 2;
    padding: ${(args) => args.layout.paddings[0]}px ${(args) => args.layout.paddings[0]}px 0;
  `

  export const ViewerContainer = styled.div<{
    layout: CameraForCountLayout,
  }>`
    width: ${(args) => args.layout.viewerContainerWidth}%;
    height: ${(args) => args.layout.viewerContainerHeight}%;
    flex-shrink: 0;
    border: ${(args) => args.layout.border}px dashed ${(args) => args.theme.color.PrimaryWhite};
  `

  export const ControllersContainer = styled.div<{
    layout: CameraForCountLayout,
  }>`
    ${cssFlexColumn}
    gap: ${(args) => args.layout.gap[1]}px;
    padding: ${(args) => args.layout.controllersContainerPadding};
  `

  export const ResultContainer = styled.div<{
    layout: CameraForCountLayout,
  }>`
    ${cssFlexColumn}
    gap: ${(args) => args.layout.gap[2]}px;
    padding: ${(args) => args.layout.resultContainerPadding};
  `

  export const CountInfoContainer = styled.div<{
    layout: CameraForCountLayout,
  }>`
  ${cssFlexRow}
    gap: ${(args) => args.layout.gap[1]}px;
  `

  export const IconInfoContainer = styled.div<{
    layout: CameraForCountLayout,
  }>`
    ${cssFlexRow}
    svg {
        height: ${(args) => args.layout.iconHeight}px;
        width: ${(args) => args.layout.iconWidth}px;
    }
    color: ${themeColors.PrimaryWhite}
  `

  export const LabelInfoContainer = styled.div<{
    layout: CameraForCountLayout,
  }>`
    ${cssFlexColumn}
    gap: ${(args) => args.layout.gap[0]}px;
  `